import { LuGithub, LuLinkedin, LuMail, LuTwitter } from 'react-icons/lu';

export const SOCIAL_LINKS = [
  { name: 'github', url: 'https://github.com/adelpro', icon: LuGithub },
  {
    name: 'linkedin',
    url: 'https://linkedin.com/in/adelpro',
    icon: LuLinkedin,
  },
  { name: 'twitter', url: 'https://twitter.com/adelpro', icon: LuTwitter },
  { name: 'email', url: 'mailto:contact@adelpro.us.kg', icon: LuMail },
] as const;

export const PROJECT_FILTERS = [
  { label: 'All', value: 'all' },
  { label: 'Web', value: 'web' },
  { label: 'Mobile', value: 'mobile' },
  { label: 'AI', value: 'ai' },
  { label: 'Game', value: 'game' },
] as const;

export const SKILLS = [
  'React',
  'Next.js',
  'TypeScript',
  'Node.js',
  'Python',
  'PostgreSQL',
  'MongoDB',
  'AWS',
  'Docker',
  'CI/CD',
] as const;

export const ANIMATION_DURATION = {
  fast: 200,
  normal: 300,
  slow: 500,
} as const;

export const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  desktop: 1280,
} as const;
